import React, { Fragment } from 'react'
import { compact } from 'lodash'
import Table from 'UI/Table'
import { nodesColumns, clusterColumns, chartColumns } from './data/Columns'
import { TrendsChart } from 'Components/Chart';

const SolidfireCapacityReport = ({ clusters, trends }) => (
  <Fragment>
    <Table
      {...{
        data: clusters,
        columns: compact(clusterColumns),
        SubComponent: ({ original: cluster }) => (
          <Table
            {...{
              columns: nodesColumns,
              data: cluster.nodes,
              showPagination: false,
            }}
          />
        ),
      }}
    />
    <TrendsChart trends={trends} chartColumns={chartColumns} />
  </Fragment>
);

export default SolidfireCapacityReport
